var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',[_vm._v("Пользовательское соглашение")]),_c('p',[_vm._v("Текст пользовательского соглашения")])])
}]

export { render, staticRenderFns }